<template>
  <v-dialog v-model="dialog" @input="v => v || closeDialog()" max-width="688px">
    <v-card>
      <v-card-title>{{ dialogTitle }}</v-card-title>
      <v-card-text>
        <div v-if="htmlContent" v-html="helpText" class="my-3"></div>
        <p v-else>{{ helpText }}</p>
      </v-card-text>
      <v-card-actions>
        <v-layout row wrap justify-center>
          <v-flex xs7 class="pr-2">
            <v-btn block flat @click="closeDialog" class="close-btn">{{
              "lng_ok" | translate
            }}</v-btn>
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "HelpDialog",
  data() {
    return {
      dialog: false
    };
  },
  props: {
    helpText: {
      type: String,
      default: ""
    },
    openDialog: {
      type: Boolean,
      default: false
    },
    closeDialog: {
      type: Function,
      default: undefined
    },
    dialogTitle: {
      type: String,
      default: "Dialog"
    },
    htmlContent:{
      type: Boolean,
      default: false
    }
  },
  watch: {
    openDialog: function(newVal) {
      this.dialog = newVal;
    }
  }
};
</script>
<style scoped>
.close-btn {
  color: rgba(0, 0, 0, 0.87);
}
</style>
